import { render, staticRenderFns } from "./ReservationsView.vue?vue&type=template&id=54c643be&"
import script from "./ReservationsView.vue?vue&type=script&lang=js&"
export * from "./ReservationsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports